import type { ReactNode } from 'react';

interface OrderContainerProps {
  children: ReactNode;
  className?: string;
}

export function OrderContainer({ children, className }: OrderContainerProps) {
  return (
    <div className={className} data-testid="orderList">
      {children}
    </div>
  );
}
